import { Pipe, PipeTransform } from "@angular/core";
import { formatAddress } from "src/app/common/format/address-format";
import { Address } from "../backend/models/address";

@Pipe({
  name: "formatAddress",
  standalone: false
})
export class FormatAddressPipe implements PipeTransform {
  transform(address: Address | undefined): string {
    return formatAddress(address);
  }
}
